import React, { useContext, VFC } from 'react';

import classNames from 'classnames';
import { Text } from 'mintel-react-ui';

import { DangerousH4 } from '../../components/common';
import { ContentContainerJson, Present, PresentOption } from '../../types';
import {
  BlockBackgroundContext,
  PresentModeContext,
} from '../../utils/contexts';
import { contentFilter } from '../../utils/functions';
import styles from './ContentColumn.scss';

const ContentColumn: VFC<
  Pick<ContentContainerJson, 'elements' | 'columnNumber' | 'numbered'> & {
    textCentered?: boolean;
    presentOption?: PresentOption;
    hide?: boolean;
  }
> = ({
  elements = {},
  columnNumber = 0,
  numbered = false,
  textCentered = false,
  presentOption = PresentOption.Default,
  hide = false,
}) => {
  const presentMode = useContext(PresentModeContext);
  const { darkBg } = useContext(BlockBackgroundContext);
  const body = contentFilter(elements.content, presentMode, presentOption);

  return (
    <div
      className={classNames({
        [styles['text-centered']]: textCentered,
        [styles[`numbered-column-${columnNumber}`]]: numbered,
        [styles.keynote]: presentMode === Present.Keynote,
        [styles.hide]: hide,
      })}
    >
      {!!elements.title && !elements.title.hidden && (
        <div className={styles.title}>
          <Text.Heading4 darkBg={darkBg}>
            <DangerousH4>{elements.title.content}</DangerousH4>
          </Text.Heading4>
        </div>
      )}
      {!!body && (
        <Text.Body darkBg={darkBg} underlineLinks>
          <div dangerouslySetInnerHTML={{ __html: body }} />
        </Text.Body>
      )}
    </div>
  );
};

export default ContentColumn;
